/**
 * useUser  thin wrapper re-exporting everything from UserContext.
 *
 * UserContext.tsx contains the actual enrichment logic (single Provider instance).
 * This file exists only for backward-compatibility: all callers of
 * `import { useUser } from "/hooks/useUser"` continue working unchanged.
 */
export {
  setPreferredUserType,
  clearPreferredUserType,
  notifyAuthChange,
  resetGlobalEnrichGuard,
  AUTH_EVENT,
} from '../context/UserContext';

export type { UserContextType as UseUserReturn } from '../context/UserContext';

import { useUserContext } from '../context/UserContext';

/** Returns user state from UserContext. */
export function useUser() {
  return useUserContext();
}
